$(document).on("turbolinks:load", () => {
  const WEEKDAYS_BUTTON_DOM = ".weekdays-btn-group";
  const HIDDEN_FIELDS_WEEKDAYS = "#hidden_field_weekdays";

  // init values on edit
  Array.from(document.querySelectorAll(`${WEEKDAYS_BUTTON_DOM}[data-active]`)).forEach((item) => {
    item.classList.replace("btn-secondary", "btn-primary");
    const { paramName, paramValue } = (item as HTMLElement).dataset;
    if (item!.parentElement!.style.display !== "none") {
      $(HIDDEN_FIELDS_WEEKDAYS).append(`<input type='hidden' value="${paramValue}" name="${paramName}">`);
    }
  });

  $(WEEKDAYS_BUTTON_DOM).on("click", (event) => {
    event.currentTarget.classList.toggle("btn-primary");
    event.currentTarget.classList.toggle("btn-secondary");
    const { paramName, paramValue } = event.currentTarget.dataset;
    const arrayClasses = Array.from(event.currentTarget.classList);
    if (arrayClasses.includes("btn-primary")) {
      $(HIDDEN_FIELDS_WEEKDAYS).append(`<input type='hidden' value="${paramValue}" name="${paramName}">`);
    } else {
      $(`input[type="hidden"][name="${paramName}"][value="${paramValue}"]`).remove();
    }
  });
});
